<template>
  <div>
    <v-dialog v-model="dialog" max-width="800" persistent scrollable>

      <v-card :loading="isLoading" :disabled="isLoading">

        <v-card-title>
          {{ title }}
          <v-spacer/>
          <v-btn icon @click="close()">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>

        <v-divider/>

        <v-card-text class="pa-10">

          <v-select v-model="form.boostingIds"
                    outlined
                    multiple
                    clearable
                    chips
                    deletable-chips
                    small-chips
                    :items="boostings"
                    item-text="name"
                    item-value="id"
                    dense
                    :error-messages="formErrors.boostingIds"
                    label="Affecter des boostes *"
          />

          <v-text-field v-model="form.name"
                        outlined
                        dense
                        :error-messages="formErrors.name"
                        label="Nom *"
          />

          <v-textarea v-model="form.description"
                      :error-messages="formErrors.description"
                      rows="2"
                      outlined
                      dense
                      label="Description (Optionnel)"
          ></v-textarea>

          <v-text-field v-model="form.supplier_account_id"
                        outlined
                        dense
                        :error-messages="formErrors.supplier_account_id"
                        label="Supplier Account ID *"
          />

          <v-row>

            <v-col cols="6">
              <v-menu v-model="dateMenu1" :close-on-content-click="false" :nudge-right="40"
                      min-width="auto"
                      offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="form.start_date"
                                label="Début *"
                                dense
                                outlined
                                prepend-inner-icon="mdi-calendar-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="form.start_date"
                               :min="form.start_date"
                               @input="dateMenu1 = false"></v-date-picker>
              </v-menu>
            </v-col>

            <v-col cols="6">
              <v-menu v-model="dateMenu2" :close-on-content-click="false" :nudge-right="40"
                      min-width="auto"
                      offset-y transition="scale-transition">
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field v-model="form.end_date"
                                label="Fin *"
                                dense
                                outlined
                                prepend-inner-icon="mdi-calendar-outline"
                                readonly
                                v-bind="attrs"
                                v-on="on"></v-text-field>
                </template>
                <v-date-picker v-model="form.end_date"
                               :min="form.end_date"
                               @input="dateMenu2 = false"></v-date-picker>
              </v-menu>
            </v-col>

          </v-row>

          <v-file-input ref="home_banner_image"
                        outlined
                        dense
                        :error-messages="formErrors.home_banner_image"
                        accept="image/png, image/jpeg, image/jpg, .svg"
                        label="Homme Banner *"
                        @change="uploadFile($event,'home_banner_image')"/>

          <v-file-input ref="scan_sheet_banner_image"
                        outlined
                        dense
                        :error-messages="formErrors.scan_sheet_banner_image"
                        accept="image/png, image/jpeg, image/jpg, .svg"
                        label="Scan Banner *"
                        @change="uploadFile($event,'scan_sheet_banner_image')"/>


          <v-file-input ref="success_lottie_path"
                        outlined
                        dense
                        :error-messages="formErrors.success_lottie_path"
                        accept=".json"
                        label="Lottie success *"
                        @change="uploadFile($event,'success_lottie_path')"/>


          <v-text-field v-model="form.order"
                        hide-details="auto"
                        outlined
                        dense
                        :error-messages="formErrors.order"
                        label="Order *"
          />


          <v-switch v-model="form.can_add_salepoint_code"
                    hide-details
                    label="Afficher le bouton « Ajouter un code POS » ?"></v-switch>

          <v-switch v-model="form.only_scan_qr_code"
                    hide-details
                    label="Utiliser uniquement le scan code QR ?"></v-switch>

          <v-switch v-model="form.is_default"
                    hide-details
                    label="Visible pour tout le monde"></v-switch>

          <v-radio-group v-if="!form.is_default"
                         v-model="form.users_assignment_type"
                         label="Affectation *" row>
            <v-radio label="Choisir" value="specify"/>
            <v-radio label="Exclure" value="exclude"/>
          </v-radio-group>

          <div class="table-border rounded-lg pa-4" v-if="!form.is_default">

            <h4 class="font-weight-medium mb-5">Filtrer les utilisateurs par :</h4>

            <v-autocomplete outlined
                            dense
                            prepend-icon="mdi-filter"
                            label="Base de données"
                            :items="databases"
                            item-value="id"
                            item-text="name"
                            multiple
                            v-model="form.filter.databases"
                            clearable
                            chips
                            small-chips
                            deletable-chips
            />

            <v-autocomplete outlined
                            prepend-icon="mdi-filter"
                            dense
                            hide-details
                            label="Wilaya"
                            clearable
                            chips
                            small-chips
                            deletable-chips
                            multiple
                            v-model="form.filter.wilayas"
                            :items="wilayas"
                            item-value="id"
                            item-text="name"
            ></v-autocomplete>

          </div>

        </v-card-text>

        <v-divider/>

        <v-card-actions>
          <v-spacer/>
          <v-btn :loading="btnLoading"
                 color="gifty"
                 dark
                 depressed
                 @click="saveData">
            <v-icon left>mdi-content-save</v-icon>
            Enregistrer
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>


  </div>
</template>

<script>
import {HTTP} from "@/http-common";

export default {
  props: ['boostings'],
  data() {
    return {
      title: null,
      btnLoading: false,
      isLoading: false,
      dialog: false,

      databases: [],
      wilayas: [],

      formErrors: {},
      form: {
       filter: {
         databases : [],
         wilayas : [],
       }
      },

      dateMenu1: false,
      dateMenu2: false
    };
  },

  methods: {
    open() {
      this.title = "Ajouter une campagne"
      this.dialog = true;
      this.resetFiles()
      this.form = {
        boostingIds: [],
        name: "",
        supplier_account_id: "",
        description: "",
        start_date: "",
        end_date: "",
        home_banner_image: "",
        scan_sheet_banner_image: "",
        success_lottie_path: "",
        order: 1,
        only_scan_qr_code: 1,
        can_add_salepoint_code: 1,
        is_default: 1,
        filter: {
          databases : [],
          wilayas : [],
        },
        users_assignment_type: 'specify',
      }
    },
    resetFiles() {
      if (this.$refs.home_banner_image) {
        this.$refs.home_banner_image.reset();
      }

      if (this.$refs.scan_sheet_banner_image) {
        this.$refs.scan_sheet_banner_image.reset();
      }

      if (this.$refs.success_lottie_path) {
        this.$refs.success_lottie_path.reset();
      }
    },
    edit(item) {
      this.title = "Modifier une campagne"
      this.resetFiles()
      this.boosting_method_id = item.id;
      this.form.boostingIds = item.boostings.map(el => el.id) ?? [];
      this.form.name = item.name;
      this.form.supplier_account_id = item.supplier_account_id;
      this.form.description = item.description;
      this.form.start_date = item.start_date;
      this.form.end_date = item.end_date;
      this.form.home_banner_image = "";
      this.form.scan_sheet_banner_image = "";
      this.form.success_lottie_path = "";
      this.form.order = item.order;
      this.form.is_default = item.is_default;
      this.form.can_add_salepoint_code = item.can_add_salepoint_code;
      this.form.only_scan_qr_code = item.only_scan_qr_code;
      this.form.users_assignment_type = item.users_assignment_type;
      this.form.filter = item.filter;
      this.dialog = true;
    },
    close() {
      this.formErrors = {};
      this.dialog = false;
    },
    uploadFile(file, field) {
      this.form[field] = file
    },
    saveData() {
      this.formErrors = {};
      this.btnLoading = true;

      const formData = new FormData();
      formData.append("id", this.boosting_method_id ?? "");
      formData.append("name", this.form.name);
      formData.append("supplier_account_id", this.form.supplier_account_id);
      formData.append("description", this.form.description);
      formData.append("start_date", this.form.start_date);
      formData.append("end_date", this.form.end_date);
      formData.append("order", this.form.order);
      formData.append("is_default", this.form.is_default ?? 1);
      formData.append("can_add_salepoint_code", this.form.can_add_salepoint_code ?? 1);
      formData.append("only_scan_qr_code", this.form.only_scan_qr_code ?? 1);
      formData.append("filter", JSON.stringify(this.form.filter));
      formData.append("users_assignment_type", this.form.users_assignment_type);

      if (this.form.home_banner_image) {
        formData.append("home_banner_image", this.form.home_banner_image);
      }
      if (this.form.scan_sheet_banner_image) {
        formData.append("scan_sheet_banner_image", this.form.scan_sheet_banner_image);
      }
      if (this.form.success_lottie_path) {
        formData.append("success_lottie_path", this.form.success_lottie_path);
      }

      this.form.boostingIds.forEach((id, index) => {
        formData.append(`boostingIds[${index}]`, id);
      });

      let url = this.boosting_method_id ? "/v1/boosting-methods/update" : "/v1/boosting-methods/store"

      HTTP.post(url, formData)
          .then(() => {
            this.$successMessage = "Cet élément a été ajouté avec succès";
            this.btnLoading = false;
            this.close();
            this.$emit("refresh");
            this.dialog = false;
          })
          .catch((err) => {
            this.btnLoading = false;
            this.formErrors = err.response.data.errors;
          });
    },

    getFilterData() {
      Promise.all([
        HTTP.get("/v1/users/databases"),
        HTTP.get("/v1/users/wilayas")
      ]).then(([databasesRes, wilayasRes]) => {
        this.databases = databasesRes.data.data
        this.wilayas = wilayasRes.data.data
      }).catch(err => {
        console.error(err)
      })
    }
  },
  created() {
    this.getFilterData()
  }
};
</script>

<style scoped>
</style>
    